import type { ProductPriceRange } from 'services/shopify';

export enum ProductType {
  skincare = 'Skincare',
  nutrition = 'Nutrition',
  accessory = 'Accessory',
}

export interface Product {
  id: string;
  productType: ProductType;
  title: string;
  availableForSale: boolean;
  priceRange: ProductPriceRange;
}
